import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { BRAND, FOUNDERS, CONTACT } from "@/lib/constants";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A1128] text-white"
    >
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img
                src={BRAND.logos.qwis}
                alt="Q-Wis"
                className="h-14 w-14 object-contain rounded-[22%]"
              />
              <img
                src={BRAND.logos.primecore}
                alt="PrimeCore Solutions"
                className="h-12 w-auto bg-white rounded px-2 py-1"
              />
            </div>
            <p className="mt-6 max-w-md font-serif-display text-2xl leading-snug text-white/90">
              {BRAND.tagline}
            </p>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-white/70">
              Q-Wis is a Windows-based smart quality and process governance
              suite, built by industry veterans for apparel manufacturing
              excellence.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-[#E8772E]">
              Navigate
            </h4>
            <ul className="mt-5 space-y-3 text-sm text-white/80">
              <li><Link data-testid="footer-link-home" to="/" className="hover:text-white">Home</Link></li>
              <li><Link data-testid="footer-link-product" to="/product" className="hover:text-white">Product</Link></li>
              <li><Link data-testid="footer-link-about" to="/about" className="hover:text-white">About</Link></li>
              <li><Link data-testid="footer-link-pricing" to="/pricing" className="hover:text-white">Pricing</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-[#E8772E]">
              Reach Us
            </h4>
            <ul className="mt-5 space-y-4 text-sm text-white/80">
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-1 shrink-0 text-white/60" />
                <a
                  data-testid="footer-email-general"
                  href={`mailto:${CONTACT.generalEmail}`}
                  className="hover:text-white"
                >
                  {CONTACT.generalEmail}
                </a>
              </li>
              {FOUNDERS.filter((f) => f.phone).map((f) => (
                <li key={f.email} className="flex items-start gap-3">
                  <span className="mt-1 inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-[#E8772E]" />
                  <div>
                    <p className="text-white/95">{f.name}</p>
                    <p className="text-white/60">{f.phone}</p>
                  </div>
                </li>
              ))}
              {CONTACT.offices.map((o) => (
                <li key={o.country} className="flex items-start gap-3">
                  <MapPin size={16} className="mt-1 shrink-0 text-white/60" />
                  <span>{o.label}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-white/50 sm:flex-row sm:items-center">
          <p>
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 tracking-wide">
            <Link data-testid="footer-link-privacy" to="/privacy" className="hover:text-white">Privacy</Link>
            <span className="text-white/20">·</span>
            <Link data-testid="footer-link-terms" to="/terms" className="hover:text-white">Terms</Link>
            <span className="text-white/20">·</span>
            <span>{BRAND.domain} · Registered in Sri Lanka &amp; Bangladesh</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
